facebookAdModalController.$inject = ['$scope', '$translate', '$uibModalInstance', 'controllerParams'];
export function facebookAdModalController($scope, $translate, $uibModalInstance, controllerParams) {

  $scope.submit = submit;
  $scope.cancel = cancel;

  init();

  function submit() {
    $uibModalInstance.close($scope.data);
  }

  function cancel() {
    $uibModalInstance.dismiss('cancel');
  }

  function init() {
    $scope.params = controllerParams;
    if (controllerParams.facebookAdType === 'html.ClickToMessengerBox') {
      $scope.procedureUrl = $translate.instant('parameters/quick_replies/details/facebook_ad/information_details_url_clic_to_messenger');
    } else if (controllerParams.facebookAdType === 'html.LineRichMenuBox') {
      $scope.procedureUrl = $translate.instant('parameters/quick_replies/details/line_rich_menu/information_details_url');
    } else {
      $scope.procedureUrl = $translate.instant('parameters/quick_replies/details/facebook_ad/information_details_url_sponsored_message');
    }
    if (controllerParams.facebookAdType === 'html.SponsoredBzcMessageBox') {
      $scope.informationText = $translate.instant('parameters/quick_replies/details/bzc_ad/information_1');
    } else if (controllerParams.facebookAdType === 'html.LineRichMenuBox') {
      $scope.informationText = $translate.instant('parameters/quick_replies/details/line_rich_menu/information_1');
      $scope.clickHereText = $translate.instant('parameters/quick_replies/details/line_rich_menu/information_clic_here');
      $scope.forMoreDetailsText = $translate.instant('parameters/quick_replies/details/line_rich_menu/information_to_open_details');
    } else {
      $scope.informationText = $translate.instant('parameters/quick_replies/details/facebook_ad/information_1');
    }
  }
}
